import { forwardRef } from 'react';
import styles from './parts.module.css';

const Button = forwardRef(({ variant = 'secondary', type = 'button', busy, disabled, children, ...rest }, ref) => (
    <button
        ref={ref}
        type={type}
        className={`${styles.btn} ${variant === 'primary' ? styles.primary : ''} ${variant === 'danger' ? styles.danger : ''}`}
        disabled={disabled || busy}
        aria-busy={busy ? 'true' : undefined}
        {...rest}
    >
        {children}
    </button>
));

export default Button;
